export const RouterKeys ={
    AUTH:{
        LOGIN:'/',
        CREATE_PASSWORD:'create_password',
        FORGOT_PASSWORD:'forgot_password',
        OTP_VERIFY:'otp-verify',
        ACCOUNT_DELETE:'account-delete-page-mobile'
    },
    NON_Auth:{
        HOME:'/dashboard',
        USERS:'/users',
        USER_Detail:'/users-detail',
        CATEGORY:'/category',
        CATEGORY_DETAIL:'/category-detail',
        COMMUNITY:'/community',
        COMMUNITY_DETAIL:'/community-detail',
        REPORT_USERS:'/report-users',
        REPORT_POST:'/report-post',
        REPORT_POST_DETAIL:'/report-post-detail',
        REPORT_COMMENTS:'/report-comments',
        REPORT_COMMENTS_DETAIL:'/report-comments-detail',
        FAQ:'/FAQ-list',
        PRIVACY:'/privacy-policy',
        TERMS_CONDITION:'/terms-condition',
        CHANGE_PASSWORD:'/change-password',
    },
    
}